define(['underscore'], (_)=> {
    return (currentVmNode, question, answers)=> {
        return {
            'visible': {
                'get': ()=> {
                    return _.every(question.filters, (filter)=> {
                        return answers[filter.questionCode] === filter.answer;
                    });
                }
            },
            'required': {
                'get': ()=> {
                    return currentVmNode.aspects.visible && question.required;
                }
            }
        };
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/questionsets/aspects/Requiredness.js